export default "__VITE_ASSET__DJrtw3l7__"